export const INCORRECT_AUTH_CODE_MULTIPLE_RETRY_ERROR = '320',
  INCORRECT_AUTH_CODE_ERROR = '321',
  BANK_SEARCH_CODE_ERROR = '027',
  INCORRECT_LINK_CODE_ERROR = '319',
  CASE_ALREADY_EXIST_CODE_745 = '745',
  CASE_ALREADY_EXIST_CODE_746 = '746',
  ACCOUNT_SERVICE_TANDC_ERROR = '401';
